<template>
    <div class="popover-explain">
        <div>
            <div class="text-black">
                {{ $t('Search.explanation.example') }}:
            </div>
            <img
                class="popover-explain__img mb-3"
                :src="imgSrc"
            >
        </div>
        <div
            v-for="(field, index) in fields"
            :key="index"
            class="popover-explain--row"
        >
            <span class="mr-1">{{ field.field }}=</span>
            <span class="popover-explain__vertical">
                <span class=" px-1">{{ field.molecule }}</span>
                <span class="popover-explain__vertica--line" />
                <span class="px-1">{{ field.denominator }}</span>
            </span>
            <span class="mx-1"> = </span>
            <span class="popover-explain__vertical">
                <span class="px-1">{{ field.moleculeValue }}</span>
                <span class="popover-explain__vertica--line" />
                <span class="px-1">{{ field.denominatorValue }}</span>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AlignmentExplanation',
    props: {
        imgSrc: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            fields: [],
        };
    },
    computed: {
        explanationImg() {
            if (this.$i18n.locale === 'en') {
                return 'explanation_EN';
            }
            return 'explanation_CN';
        },
    },
    watch: {
        '$i18n.locale': {
            handler() {
                this.fields = this.generatFields();
            },
            immediate: true,
        },
    },
    methods: {
        generatFields() {
            return [{
                field: `${this.$t('Search.labels.similarity')}`,
                molecule: this.$t('Search.explanation.identityLength'),
                denominator: this.$t('Search.explanation.alignLength'),
                moleculeValue: '4',
                denominatorValue: '5',
            }, {
                field: `${this.$t('Search.labels.queryIdentity')}`,
                molecule: this.$t('Search.explanation.identityLength'),
                denominator: this.$t('Search.explanation.queryLength'),
                moleculeValue: '4',
                denominatorValue: '10',
            }, {
                field: `${this.$t('Search.labels.qconv')}`,
                molecule: this.$t('Search.explanation.alignLength'),
                denominator: this.$t('Search.explanation.queryLength'),
                moleculeValue: '5',
                denominatorValue: '10',
            }, {
                field: `${this.$t('Search.labels.subjectIdentity')}`,
                molecule: this.$t('Search.explanation.identityLength'),
                denominator: this.$t('Search.explanation.subjectLength'),
                moleculeValue: '4',
                denominatorValue: '12',
            }, {
                field: `${this.$t('Search.labels.subjectCoverage')}`,
                molecule: this.$t('Search.explanation.alignLength'),
                denominator: this.$t('Search.explanation.subjectLength'),
                moleculeValue: '5',
                denominatorValue: '12',
            }];
        },
    },
};
</script>
